import Container from 'components/atoms/layout/Container/Container';
import { PixelModule } from 'components/modules/PixelModules';
import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { setCurrentPage } from 'store/slices/ui.slice';

export const Pixel = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.analytics.page("Pixel");
    dispatch(setCurrentPage('settings'));
  }, [dispatch]);

  return (
    <Container className='p-10'>
      <PixelModule />
    </Container>
  );
};